import { FormStatusEnum } from "@/components/molecules/FormWrapper/FormWrapper.types";
import { useEffect, useState } from "react";
import { useTitle } from "@/core/context/TitleContext";
import { Loading } from "@/components/atoms/Loading/Loading";
import { FormHeader } from "@/components/molecules/FormHeader/FormHeader";
import { DataTable } from "@/components/molecules/DataTable/DataTable";
import { useSensitivityMeasuresData } from "@/modules/dashboard/application/hooks/useSensitivityMeasuresData";
import { aggregatedByPortfoliosColumns, sensitivityMeasuresColumns } from "@/modules/dashboard/infrastructure/DashboardConstants";
import { SensitivityMeasures, SensitivityMeasuresByPortfolio } from "@/modules/dashboard/domain/entities/DashboardEntity";

// Componente funcional
export const SensitivityMeasuresPage = () => {
  const [formStatus, setFormStatus] = useState<FormStatusEnum>(FormStatusEnum.List);
  const [aggregatedByPortfolioSelected, setAggregatedByPortfolioSelected] = useState<SensitivityMeasuresByPortfolio>();
  const [aggregatedByPortfolioFiltered, setAggregatedByPortfolioFiltered] = useState<SensitivityMeasures[]>();
  const [, setFormKey] = useState(0);
  const { setTitle } = useTitle();
  const {
    sensitivityMeasures,
    aggregatedByPortfolio,
    isLoading,
    sensitivityMeasuresRefetch
  } = useSensitivityMeasuresData();

  // effects
  useEffect(() => {
    setTitle("Dashboard");
  }, []);

  useEffect(() => {
    setAggregatedByPortfolioFiltered(() => sensitivityMeasures.filter(sm => sm.portfolio === aggregatedByPortfolioSelected?.portfolio))
  }, [aggregatedByPortfolioSelected]);

  const handleChangeFormStatus = (statusOrUpdater: FormStatusEnum | ((prevState: FormStatusEnum) => FormStatusEnum)) => {
    const nextStatus = typeof statusOrUpdater === 'function'
      ? (statusOrUpdater as (prev: FormStatusEnum) => FormStatusEnum)(formStatus)
      : statusOrUpdater;

    if (nextStatus === FormStatusEnum.List) {
      setAggregatedByPortfolioSelected(undefined);
      setFormKey(prev => prev + 1);
    }

    setFormStatus(nextStatus);
  };

  if (
    isLoading
  ) return <Loading />;

  return (
    <>
      <FormHeader
        title="Medidas de sensibilidad"
        subtitle={aggregatedByPortfolioSelected?.portfolio}
        changeFormStatus={handleChangeFormStatus}
        formStatus={formStatus}
        selectItem={setAggregatedByPortfolioSelected}
        refetch={sensitivityMeasuresRefetch}
      />

      {formStatus === FormStatusEnum.List ? (
        <DataTable
          data={aggregatedByPortfolio}
          columns={aggregatedByPortfoliosColumns}
          tableHeadClass="bg-primary-500 text-white"
          pageSize={10}
          changeFormStatus={setFormStatus}
          selectItem={setAggregatedByPortfolioSelected}
        />
      ) : (
        <DataTable
          data={aggregatedByPortfolioFiltered || []}
          columns={sensitivityMeasuresColumns}
          tableHeadClass="bg-primary-500 text-white"
          pageSize={10}
          changeFormStatus={setFormStatus}
        />
      )}
    </>
  );
};
